import classNames from 'classnames/bind';
import React from 'react';

import style from './DefaultImage.module.scss';

const cx = classNames.bind(style);

const DefaultImage = ({ ...props }) => (
  <svg width="155px" height="155px" viewBox="0 0 155 155" {...props}>
    <g
      id="ImageNotAvailable_Content-155px"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect fill="#FFFFFF" x="0" y="0" width="155" height="155" />
      <rect
        id="Rectangle-Copy-5"
        fill="#F8F8F8"
        x="0"
        y="0"
        width="155"
        height="155"
      />
      <g id="Group" transform="translate(-1.000000, 0.000000)">
        <g id="Icons-/-Brand-/-RI" fill="#F2F3F3" fillRule="evenodd">
          <path
            d={`M113.914807,155.971532 C100.308316,156.919644 86.7018256,
              153.75927 74.6774848,147.122484 C63.2860041,139.221548
              56.6409736,126.264014 57.2738337,112.358367 C57.2738337,
              85.4951858 74.3610548,70.0093519 74.3610548,45.3584326
              C74.3610548,29.2405238 67.3995943,15.6509144 38.2880325,
              15.6509144 L24.0486815,15.6509144 L24.0486815,156.28757 L0,
              156.28757 L0,0.165080502 L42.0851927,0.165080502 C55.6916836,
              -0.783031779 69.2981744,2.37734249 81.3225152,9.01412846
              C92.7139959,16.9150641 99.3590264,29.8725987 98.7261663,
              43.7782455 C98.7261663,70.3253893 81.6389452,87.3914104
              81.6389452,110.77818 C81.6389452,127.212126 88.6004057,140.485698
              117.711968,140.485698 L131.951318,140.485698 L131.951318,
              0.165080502 L156,0.165080502 L156,155.971532 L113.914807,
              155.971532 L113.914807,155.971532 Z`}
            id="path-1"
          />
        </g>
        <text className={cx('image-not-available')}>
          <tspan x="45.32" y="55">
            Image
          </tspan>
          <tspan x="60.992" y="85">
            not
          </tspan>
          <tspan x="30.836" y="115">
            available
          </tspan>
        </text>
      </g>
    </g>
  </svg>
);

export default DefaultImage;
